import sharify from 'sharify'

export default () => sharify.data.CURRENT_USER
